import { render, staticRenderFns } from "./CustomRequestForm.vue?vue&type=template&id=4b14fa34&scoped=true"
import script from "./CustomRequestForm.vue?vue&type=script&lang=js"
export * from "./CustomRequestForm.vue?vue&type=script&lang=js"
import style0 from "./CustomRequestForm.vue?vue&type=style&index=0&id=4b14fa34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b14fa34",
  null
  
)

export default component.exports